import { ChurningRecord } from "@/modules/Churning/interfaces/churningResponse.interface";

export interface IChurningState {
  churningData: ChurningRecord[] | null;
  isLoading: boolean;
  error: string | null;
}

const state: IChurningState = {
  churningData: null,
  isLoading: false,
  error: null,
};

export default state;
